import moment from "moment";

export function getTimestamp() {
    return moment(new Date()).format("YYYY-MM-DDTHH:mm:ss.SSSZ");
}